module.exports = __webpack_public_path__ + "static/img/Challenge_Img.ace97b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Challenge_Img.jpg
// module id = 36
// module chunks = 0